import { call, put, takeLatest } from "redux-saga/effects"
import {
  getConfigurationApi,
  putConfigurationApi,
} from "services/control-panel"
import {
  GET_CONFIGURATION_WATCHER,
  PUT_CONFIGURATION_WATCHER,
} from "./constants"
import {
  getConfigurationWatcher,
  getConfigurationSuccess,
  getConfigurationFailed,
  putConfigurationSuccess,
  putConfigurationFailed,
} from "./actions"

export function* getConfigurationSaga() {
  try {
    const { data, status } = yield call(getConfigurationApi)

    if (status === 200) {
      yield put(getConfigurationSuccess(data.data))
    }
  } catch (error) {
    yield put(getConfigurationFailed())
    returnMessage(error)
  }
}

export function* putConfigurationSaga(action) {
  try {
    const {
      data: { data },
    } = yield call(putConfigurationApi, action.payload)

    window.message.success(data.msj, 5)
    yield put(putConfigurationSuccess())
    yield put(getConfigurationWatcher())
  } catch (error) {
    yield put(putConfigurationFailed())
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* configurationSaga() {
  yield takeLatest(GET_CONFIGURATION_WATCHER, getConfigurationSaga)
  yield takeLatest(PUT_CONFIGURATION_WATCHER, putConfigurationSaga)
}
